import React from 'react';
import { CatHeadline, IdInput, IdResult, IdInfo, BtnCreate, CatTopic, CatTitle, ColLow, GroupBox, ColContainer, Cols, BtnDownload } from '../components/component';
import { DefaultLink } from '../components/jptr-default.js';
import { useState } from 'react';


export default function Cntntmrg() {

    const [linkId, setLinkId] = useState(DefaultLink.ID);
    const [linkInfo, setLinkInfo] = useState(DefaultLink.INFO);

    const handleClick = () => {
        setLinkId(DefaultLink.RandomID());
        setLinkInfo(DefaultLink.RandomINFO());
    };

    return (
        <div className='flx-Vl-6'>
            <ColContainer>
                <ColLow>
                    <CatHeadline name="mergelink" />
                    <p style={{ color: 'var(--c3)' }}>These options are not yet implemented.</p>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                        et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
                        deserunt mollit anim id est laborum.
                    </p>
                </ColLow>
            </ColContainer>

            <div className='flx-2row-600na'>
                <ColContainer>
                    <GroupBox>
                        <Cols>
                            <CatTitle name="List of Link-IDs" />
                            <IdInput name="mergelink" />
                            <IdInput name="mergelink" />
                            <IdInput name="mergelink" />
                            <IdInput name="mergelink" />
                        </Cols>
                        <BtnCreate label="create" onClick={handleClick} />
                    </GroupBox>
                </ColContainer>

                <ColContainer>
                    <Cols>
                        <IdResult linkId={linkId} />
                        <IdInfo {...linkInfo} />
                    </Cols>

                    <BtnDownload label="Download" />
                </ColContainer>
            </div>
        </div>
    );
}